<template>
  <Form url="/perfil-tributario/update" v-if="!loader" :perfilTributario="perfilTributario" />
</template>

<script>
import Form from "./Form.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "app-perfil-tributario-update",
  data() {
    return {
      perfilTributario: {},
      loader: true,
    };
  },
  components: {
    Form,
  },
  methods: {
    async getPerfilTributario(id) {
      try {
        const { data } = await this.$http.post("/perfil-tributario/find", {
          id: id,
        });
        
        console.log("Response from /perfil-tributario/find:", data);
        
        // Verifica se há dados na resposta (pode estar em data.data ou diretamente em data)
        let perfilData = null;
        
        if (data.data) {
          perfilData = data.data;
        } else if (data.id || data.descricao) {
          // Se os dados estão diretamente no retorno
          perfilData = data;
        }
        
        // Log para debug
        if (!perfilData) {
          console.warn("Nenhum dado encontrado na resposta:", data);
        }
        
        return perfilData;
      } catch (error) {
        console.error("Erro na requisição de perfil tributário:", error);
        return null;
      }
    },
    async getInit() {
      try {
        const id = this.$route.params.id;

        if (!id) {
          this.$toast.error("ID do Perfil Tributário não fornecido!");
          this.$router.push({ name: "perfilTributarioLista" });
          return;
        }

        const perfilTributario = await this.getPerfilTributario(id);

        // Aceita qualquer objeto que tenha uma propriedade 'descricao' ou 'id'
        if (!perfilTributario || (!perfilTributario.descricao && !perfilTributario.id)) {
          this.$toast.error("Perfil Tributário não encontrado!");
          console.warn("Dados de perfil inválidos:", perfilTributario);
          this.$router.push({ name: "perfilTributarioLista" });
          return;
        }

        this.perfilTributario = perfilTributario;
        this.loader = false;
      } catch (error) {
        console.error("Erro ao carregar perfil tributário:", error);
        this.$toast.error("Erro ao carregar perfil tributário!");
        this.$router.push({ name: "perfilTributarioLista" });
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Perfil Tributário"
      }
    ]);
    this.getInit();
  },
};
</script>
